
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SelectAlgoType extends Vue {
    @Prop() algoType!: string;
    @Prop() disabled!: boolean;

    items = [
        { value: 'simple_algo', text: 'Hysteresis' },
        { value: 'pid_algo', text: 'PID' }
    ];

    get localAlgoType() {
        return this.algoType;
    }

    set localAlgoType(value: string) {
        this.$emit('set-algo-type', value);
    }

}
